export const serviceListResidenciales = [
  {
    "title": "SERVICIO DE",
    "subtitle": "<span>RESTAURACIÓN DE EDIFICIOS</span><br /> Y ESTRUCTURAS",
    "description": "El óxido en las estructuras es una amenaza constante que debilita el metal y pone en riesgo la estabilidad y durabilidad de la misma. Dale la limpieza adecuada con nuestros servicios especializados.",
    "features": ["Recubrimientos", "Reparación y Sellado de Fachadas", "Reparación de Balcones", "Rope Access"],
    "buttonText": "CONTACTANOS",
    "images": [
      "/assets/imgs/services/industriales/serviceList/1.jpg",
      "/assets/imgs/services/industriales/serviceList/1.jpg",
      "/assets/imgs/services/industriales/serviceList/1.jpg"
    ],
    "bgColor": "#EA0029"
  },
  {
    "title": "SERVICIO DE",
    "subtitle": "MANTENIMIENTO",
    "description": "La prevención es la clave para tener en óptimas condiciones sus estructuras. Nosotros realizamos las inspecciones necesarias de manera no invasiva.",
    "features": [
      "Limpieza de Ventanas",
      "Limpieza de Fachadas",
      "Reparación de Grietas",
      "Rope Access",
      "Aplicación de recubrimientos cementicios y no cementicios.",
      "Reparación de bajantes pluviales exteriores",
    ],
    "buttonText": "CONTACTANOS",
    "images": [
      "/assets/imgs/services/industriales/serviceList/2.jpg",
      "/assets/imgs/services/industriales/serviceList/2.jpg",
      "/assets/imgs/services/industriales/serviceList/2.jpg"
    ],
    "bgColor": "#EA0029"
  },
  {
    "title": "SERVICIO DE",
    "subtitle": "PINTURA",
    "description": "La prevención es la clave para tener en óptimas condiciones sus estructuras. Nosotros realizamos las inspecciones necesarias de manera no invasiva.",
    "features": [
      "Edificios Residenciales",
      "Estructuras",
      "Pisos Epóxicos",
      "Pintura en Muros interior y exterior",
      "Impermeabilizantes",
      "Aislamientos Térmicos",
    ],
    "buttonText": "CONTACTANOS",
    "images": [
      "/assets/imgs/services/industriales/serviceList/3.jpg",
      "/assets/imgs/services/industriales/serviceList/3.jpg",
      "/assets/imgs/services/industriales/serviceList/3.jpg"
    ],
    "bgColor": "#EA0029"
  },
  {
    "title": "SERVICIO DE",
    "subtitle": "INSTALACIÓN",
    "description": "La prevención es la clave para tener en óptimas condiciones sus estructuras. Nosotros realizamos las inspecciones necesarias de manera no invasiva.",
    "features": [
      "Fachadas",
      "Alucobond",
      "Pluviales",
      "Eléctricas",
      "Piedra",
      "Estructuras",
      "Anclajes",
    ],
    "buttonText": "CONTACTANOS",
    "images": [
      "/assets/imgs/services/industriales/serviceList/4.jpg",
      "/assets/imgs/services/industriales/serviceList/4.jpg",
      "/assets/imgs/services/industriales/serviceList/4.jpg"
    ],
    "bgColor": "#EA0029"
  },
]

export const serviceListResidencialesEn = [
  {
    title: "SERVICE OF",
    subtitle: "<span>BUILDING RESTORATION</span><br />AND STRUCTURES",
    description:
      "Rust on structures is a constant threat that weakens metal and jeopardizes stability and durability. Give them the proper cleaning with our specialized services.",
    features: [
      "Coatings",
      "Facade Repair and Sealing",
      "Balcony Repair",
      "Rope Access"
    ],
    buttonText: "CONTACT US",
    "images": [
      "/assets/imgs/services/industriales/serviceList/1.jpg",
      "/assets/imgs/services/industriales/serviceList/1.jpg",
      "/assets/imgs/services/industriales/serviceList/1.jpg"
    ],
    bgColor: "#EA0029"
  },
  {
    title: "SERVICE OF",
    subtitle: "MAINTENANCE",
    description:
      "Prevention is key to keeping your structures in optimal condition. We perform the necessary inspections in a non-invasive manner.",
    features: [
      "Window Cleaning",
      "Facade Cleaning",
      "Crack Repair",
      "Rope Access",
      "Application of Cementitious & Non-Cementitious Coatings",
      "Exterior Downspout Repair"
    ],
    buttonText: "CONTACT US",
    "images": [
      "/assets/imgs/services/industriales/serviceList/2.jpg",
      "/assets/imgs/services/industriales/serviceList/2.jpg",
      "/assets/imgs/services/industriales/serviceList/2.jpg"
    ],
    bgColor: "#EA0029"
  },
  {
    title: "SERVICE OF",
    subtitle: "PAINTING",
    description:
      "Prevention is key to keeping your structures in optimal condition. We perform the necessary inspections in a non-invasive manner.",
    features: [
      "Residential Buildings",
      "Structures",
      "Epoxy Flooring",
      "Interior & Exterior Wall Painting",
      "Waterproofing",
      "Thermal Insulation"
    ],
    buttonText: "CONTACT US",
    "images": [
      "/assets/imgs/services/industriales/serviceList/3.jpg",
      "/assets/imgs/services/industriales/serviceList/3.jpg",
      "/assets/imgs/services/industriales/serviceList/3.jpg"
    ],
    bgColor: "#EA0029"
  },
  {
    title: "SERVICE OF",
    subtitle: "INSTALLATION",
    description:
      "Prevention is key to keeping your structures in optimal condition. We perform the necessary inspections in a non-invasive manner.",
    features: [
      "Facades",
      "Alucobond",
      "Rainwater Systems",
      "Electrical Works",
      "Stone",
      "Structures",
      "Anchors"
    ],
    buttonText: "CONTACT US",
    "images": [
      "/assets/imgs/services/industriales/serviceList/4.jpg",
      "/assets/imgs/services/industriales/serviceList/4.jpg",
      "/assets/imgs/services/industriales/serviceList/4.jpg"
    ],
    bgColor: "#EA0029"
  }
];
